import { useEffect } from "react";
import { App } from "antd";
import { registerNotify } from "./notify";

// Rendered inside antd's <App> — registers the React-19-safe notification/message
// instances so the module-level `notify` helper works anywhere.
export default function NotifyBridge() {
  const { notification, message } = App.useApp();
  useEffect(() => {
    registerNotify(notification, message);
  }, [notification, message]);
  return null;
}
